import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { isSoftLaunchEnabled } from "@/data/softLaunchStore";
import { useState, useEffect } from "react";
import ComingSoonPage from "@/pages/ComingSoonPage";

interface SoftLaunchGuardProps {
  children: React.ReactNode;
}

export default function SoftLaunchGuard({ children }: SoftLaunchGuardProps) {
  const { isAuthenticated, user, isParty, isOng, isInstitution, isMedia } = useAuth();
  const location = useLocation();
  const [softLaunchMode, setSoftLaunchMode] = useState(isSoftLaunchEnabled());

  useEffect(() => {
    const handleModeChange = (e: any) => setSoftLaunchMode(e.detail.enabled);
    window.addEventListener("softLaunchModeChanged", handleModeChange);
    return () => window.removeEventListener("softLaunchModeChanged", handleModeChange);
  }, []);

  // Allowed roles during Soft Launch
  const isAllowedPartner = isAuthenticated && (isParty || isOng || isInstitution || isMedia || user?.role === 'ADMIN' || user?.adminLevel === 'SUPER_ADMIN' || user?.partyAcronym === 'SAP');

  // If soft launch is OFF, or if user is an allowed partner, let them through
  if (!softLaunchMode || isAllowedPartner) {
    return <>{children}</>;
  }

  // Otherwise, render the ComingSoonPage directly without redirecting
  return <ComingSoonPage />;
}
